// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3gtbW","title":"BackImages_title__7nGID","images":"BackImages_images__2FHaY"};